export const dop_pokritie_verstak = {
    zink__verstak__1200x630: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1200x630",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__verstak__1500x630: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1500x630",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    zink__verstak__1800x630: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Оцинковка, 1800x630",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    metall2mm__verstak__1200x630: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Металл 2 мм, 1200x630",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    metall2mm__verstak__1500x630: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Металл 2 мм, 1500x630",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    metall2mm__verstak__1800x630: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Металл 2 мм, 1800x630",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    metall6mm__verstak__1200x630: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Металл 6 мм, 1200x630",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    metall6mm__verstak__1500x630: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Металл 6 мм, 1500x630",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    metall6mm__verstak__1800x630: {
        name: "Доп. покрытие столешницы, мм",
        price: 0,
        active: false,
        type: "Металл 6 мм, 1800x630",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
export const verstak__vs__tumba = {
    verstak__vs__1200x630_t1: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1200x630, t1",
        width: 1200,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1200x630_t2: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1200x630, t2",
        width: 1200,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1200x630_t3: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1200x630, t3",
        width: 1200,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1200x630_t4: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1200x630, t4",
        width: 1200,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1200x630_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1200x630, t5",
        width: 1200,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },

    verstak__vs__1500x630_t1: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t1",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1500x630_t2: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t2",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1500x630_t3: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t3",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1500x630_t4: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t4",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1500x630_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t5",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },

    verstak__vs__1800x630_t1: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t1",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1800x630_t2: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t2",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1800x630_t3: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t3",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1800x630_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t5",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
};
export const verstak__vs__2_tumba = {
    verstak__vs__1500x630_t1_t1: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t1 t1",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1500x630_t1_t2: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t1 t2",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1500x630_t1_t3: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t1 t3",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1500x630_t1_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t1 t5",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },

    verstak__vs__1500x630_t2_t2: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t2 t2",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1500x630_t2_t3: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t2 t3",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1500x630_t2_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t2 t5",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },

    verstak__vs__1500x630_t3_t3: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t3 t3",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1500x630_t3_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t3 t5",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },

    verstak__vs__1500x630_t5_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1500x630, t5 t5",
        width: 1500,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },

    verstak__vs__1800x630_t1_t1: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t1 t1",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1800x630_t1_t2: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t1 t2",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1800x630_t1_t3: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t1 t3",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1800x630_t1_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t1 t5",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },

    verstak__vs__1800x630_t2_t2: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t2 t2",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1800x630_t2_t3: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t2 t3",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1800x630_t2_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t2 t5",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },

    verstak__vs__1800x630_t3_t3: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t3 t3",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
    verstak__vs__1800x630_t3_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t3 t5",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },

    verstak__vs__1800x630_t5_t5: {
        name: 'Верстак "ВС", мм',
        title: 'Верстак "ВС"',
        price: 0,
        active: false,
        type: "1800x630, t5 t5",
        width: 1800,
        depth: 630,
        piece: 1,
        price_esd: 0,
        position: "table",
    },
};

export const perfopanel_verstak = {
    perfopanel__verstak__1200x430: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1200x430",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__verstak__1200x700: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1200x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__verstak__1500x430: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1500x430",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__verstak__1500x700: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1500x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__verstak__1800x430: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1800x430",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    perfopanel__verstak__1800x700: {
        name: "Перфопанель, мм",
        price: 0,
        active: false,
        type: "1800x700",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
export const planka_dlya_lotkov_plv = {
    planka_dlya_lotkov_plv__1200: {
        name: "Планка для лотков, мм",
        price: 0,
        active: false,
        type: "1200",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov_plv__1500: {
        name: "Планка для лотков, мм",
        price: 0,
        active: false,
        type: "1500",
        piece: 0,
        price_esd: 0,
        position: null,
    },
    planka_dlya_lotkov_plv__1800: {
        name: "Планка для лотков, мм",
        price: 0,
        active: false,
        type: "1800",
        piece: 0,
        price_esd: 0,
        position: null,
    },
};
